import useApiQuery from 'shared/hooks/use-api-query';
import {BaseAdditionalGroupProps} from '../types';

const useBaseAdditionalGroupsSelect = () => {
  const {data = [], ...rest} = useApiQuery<BaseAdditionalGroupProps[]>({
    url: '/base-additional-groups/all',
  });

  return {
    ...rest,
    data: data?.map((baseAdditionalGroup: BaseAdditionalGroupProps) => ({
      label: baseAdditionalGroup.description,
      value: baseAdditionalGroup.id,
      data: baseAdditionalGroup,
    })),
  };
};

export default useBaseAdditionalGroupsSelect;
